import { render, staticRenderFns } from "./AkinonSelectSize.vue?vue&type=template&id=460cbc35"
import script from "./AkinonSelectSize.vue?vue&type=script&lang=js"
export * from "./AkinonSelectSize.vue?vue&type=script&lang=js"
import style0 from "./AkinonSelectSize.vue?vue&type=style&index=0&id=460cbc35&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports